// Label key of the greeting for the time of day (the label carries the {{username}} token).
export const getGreetingKey = (now = new Date()) => {
  const hour = now.getHours();
  if (hour < 13) return "homeGreetingMorning";
  if (hour < 18) return "homeGreetingAfternoon";
  return "homeGreetingEvening";
};
